// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ia-0";